import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'bd-flat-error',
  template: `
    <span class="bd-error bd-warn-text bd-flat-error">
      <ng-content></ng-content>
    </span>
  `,
  styles: [
    `
      .bd-error {
        font-size: 1em;
        font-weight: 500;
      }
    `,
  ],

  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class BdFlatErrorComponent {}
